import _ from 'lodash'

export default {
	name : 'question-modal',
	data () {
		return {
			title : '',
			question : '',
			active : false
		}
	},
	methods : {
		optionSelected (response) {

			let vm = this

			vm.active = false

			vm.cb(response)

		},
		cb () {}
	},
	created () {

		let vm = this

		vm.$root.$on('question-modal', (data) => {
		
			vm.active = true
			vm.title = data[0].title
			vm.question = data[0].question

			vm.cb = data[1]
		
		})

	}
}


// WEBPACK FOOTER //
// ./src/components/general/question-modal/script.js